module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-bg-5d6e9a283e3040f5ae18bf910646c50f.png";